import React from "react";
import "./css/Loading.css";

const Loading = () => {
  return (
    <div className="mainBody">
      <div className="loader">
        <div className="text">Loading</div>
        <div className="dots">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  );
};

export default Loading;
